import type { SupabaseClient } from '../supabase/client';
import type {
  UpdateStoreManualOrderApprovalInput,
  UpdateStoreManualOrderApprovalResult,
} from '../types/store';

export async function updateStoreManualOrderApproval(
  client: SupabaseClient,
  input: UpdateStoreManualOrderApprovalInput,
): Promise<UpdateStoreManualOrderApprovalResult> {
  const { data, error } = await client.rpc('set_store_manual_order_approval', {
    target_store_id: input.storeId,
    enabled: input.enabled,
  } as never);
  if (error) throw error;
  if (!data) throw new Error('set_store_manual_order_approval: empty result');
  return data as unknown as UpdateStoreManualOrderApprovalResult;
}
